export default function ($translate) {
    return {
        KEYS: {
            SUPER_ADMIN: 'SUPER_ADMIN'
        },
        LABELS: {
            SUPER_ADMIN: $translate.instant('role.specialPrivilege.superAdmin')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/role/specialPrivilege/index.js